interface RiveContentsLike {
  artboards?: { name: string; stateMachines?: { name: string }[] }[];
}

interface DiagnoseArgs {
  contents: RiveContentsLike | undefined;
  artboard?: string;
  stateMachineName?: string;
  autoBind?: boolean;
  hasViewModelInstance: boolean;
}

export interface RiveContentsDiagnosis {
  problems: string[];
  fileArtboards: string[];
  fileStateMachines: string[];
}

/**
 * Compare what a consumer asked `useRive` for against what the loaded file actually contains.
 * Rive ignores an artboard or state machine it can't find and leaves `viewModelInstance` null
 * instead of throwing, so all three failures present as a blank canvas with no error.
 */
export const diagnoseRiveContents = ({
  contents,
  artboard,
  stateMachineName,
  autoBind,
  hasViewModelInstance,
}: DiagnoseArgs): RiveContentsDiagnosis => {
  const artboards = contents?.artboards ?? [];
  const matchedArtboard = artboard ? artboards.find((entry) => entry.name === artboard) : artboards[0];
  const fileStateMachines = matchedArtboard?.stateMachines?.map((machine) => machine.name) ?? [];

  const problems: string[] = [];
  if (artboard && !matchedArtboard) {
    problems.push(`artboard "${artboard}" is not in the file`);
  }
  if (matchedArtboard && stateMachineName && !fileStateMachines.includes(stateMachineName)) {
    problems.push(`state machine "${stateMachineName}" is not on artboard "${matchedArtboard.name}"`);
  }
  if (autoBind && !hasViewModelInstance) {
    problems.push('autoBind was requested but the file exposes no bindable view model');
  }

  return {
    problems,
    fileArtboards: artboards.map((entry) => entry.name),
    fileStateMachines,
  };
};
